import {
  Box,
  Checkbox,
  FormControlLabel,
  Tooltip,
  Typography,
} from '@mui/material'
import type {
  TemplateNodeSchema,
  TemplateQuestion,
} from '@ulysses-inc/harami_api_client'
import { useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import {
  buildAnswerOptionQuestionPatch,
  selectSelectedMasterFieldDefItemName,
} from 'src/state/ducks/templates/selectors'
import type { RootState } from 'src/state/store'
import { OptionColWrapper, OptionWrapper } from '../questionOptions/dumb'
import { EditProductMasterAutofillSettingModal } from './EditProductMasterAutofillSettingModal'

type Props = {
  node: TemplateNodeSchema
  onSave: (questionPatch: Partial<TemplateQuestion>) => void
}

export const EditProductMasterAutofillSettingCheckBox = ({
  node,
  onSave,
}: Props) => {
  const [isOpenModal, setIsOpenModal] = useState(false)

  const selectedMasterFieldDefItemName = useSelector(
    selectSelectedMasterFieldDefItemName(node.question?.answerOption),
    shallowEqual,
  )

  // マスタが選択されていないと自動入力設定は無効
  const masterUuid = useSelector(
    (state: RootState) => state.templatesState.editTemplate.masterUuid,
    shallowEqual,
  )
  const isDisabledByNoMaster = !masterUuid

  const handleClick = () => {
    if (isDisabledByNoMaster) return
    if (!selectedMasterFieldDefItemName) {
      setIsOpenModal(true)
    } else {
      // 自動入力を解除(answerOption=undefined)
      onSave(buildAnswerOptionQuestionPatch(undefined))
    }
  }

  return (
    <>
      <OptionWrapper>
        <OptionColWrapper>
          <Tooltip
            title={
              isDisabledByNoMaster
                ? '製品マスタを指定すると、項目を参照できます'
                : ''
            }
          >
            <span>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={handleClick}
                    checked={!!selectedMasterFieldDefItemName}
                    disabled={isDisabledByNoMaster}
                    data-testid="master-autofill-checkbox"
                  />
                }
                label={
                  <Typography
                    variant="body2"
                    color={
                      isDisabledByNoMaster ? 'text.disabled' : 'text.primary'
                    }
                    sx={{
                      display: 'flex',
                      maxWidth: 256,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    製品マスタから自動入力
                    {selectedMasterFieldDefItemName && (
                      <>
                        {'('}
                        <Box
                          component="span"
                          sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {selectedMasterFieldDefItemName}
                        </Box>
                        {')'}
                      </>
                    )}
                  </Typography>
                }
              />
            </span>
          </Tooltip>
        </OptionColWrapper>
      </OptionWrapper>
      {isOpenModal && (
        <EditProductMasterAutofillSettingModal
          onClose={() => setIsOpenModal(false)}
          questionNode={node}
          onSave={onSave}
        />
      )}
    </>
  )
}
